export default {"src":"/_next/static/media/wallet-binance.caa66a14.svg","height":24,"width":24};